var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/editor/toolbar/x-editor-toolbar.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/fonts/fonts";
import "@adornis/popover/x-tooltip";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import "prosemirror-view";
function renderMenuItemIcon({
  view,
  isActive,
  icon,
  run,
  color
}) {
  return html`
    <x-icon
      ${css({
    fontSize: "28px",
    cursor: "pointer",
    padding: "2px",
    background: isActive ? "var(--color-base-200, #F2F2F1)" : "transparent",
    borderRadius: "4px",
    color: color ?? "var(--color-base-content, #333)"
  })}
      @click=${(e) => {
    if (!run)
      return;
    run(view);
    view.focus();
  }}
    >
      ${icon}
    </x-icon>
  `;
}
function renderMenuItem(item, view) {
  const onClick = () => {
    if (!item.run)
      return;
    item.run(view);
    view.focus();
  };
  if (item.shouldVisualize && !item.shouldVisualize(view))
    return nothing;
  if (item.render)
    return html` <div @click=${onClick}>${item.render(view)}</div> `;
  const isActive = item.isActive?.(view) ?? false;
  return html`
    <x-flex>
      ${item.label ? html` <x-tooltip .text=${html` <x-text> ${item.label} </x-text>`}></x-tooltip> ` : nothing}
      ${item.icon ? renderMenuItemIcon({ view, isActive, icon: item.icon, run: item.run, color: item.color }) : html`
            <x-flex
              ${acss({
    cursor: "pointer",
    background: isActive ? "var(--color-base-300, #4b6584)" : "",
    color: isActive ? "var(--color-base-100, #fff" : "",
    padding: "8px",
    borderRadius: "4px",
    "&:hover": {
      background: isActive ? "" : "var(--color-base-200, #F2F2F1)"
    }
  })}
              @click=${onClick}
            >
              <x-text> ${item.label} </x-text>
            </x-flex>
          `}
    </x-flex>
  `;
}
var XEditorToolbar = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.menuItems = [];
    this.menuItemGroupOrder = [];
  }
  render() {
    const view = this.view;
    if (!view)
      return nothing;
    const menuItems = this._buildMenu(view);
    return html` <x-flex horizontal crossaxis-center wrap space="sm"> ${menuItems} </x-flex> `;
  }
  _buildMenu(view) {
    const groups = this.menuItemGroupOrder;
    const result = [];
    for (const group of groups) {
      const items = this._getAllMenuItemsForGroup(group);
      for (const item of items) {
        result.push(renderMenuItem(item, view));
      }
    }
    const notGroupedItems = this.menuItems.filter((item) => !item.group || !groups.includes(item.group));
    for (const item of notGroupedItems) {
      result.push(renderMenuItem(item, view));
    }
    return result;
  }
  _getAllMenuItemsForGroup(group) {
    return this.menuItems.filter((item) => item.group === group);
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          background: "var(--color-base-200, rgb(245, 245, 245))",
          borderBottom: "1px solid var(--color-base-300, rgb(221, 221, 221))",
          display: "block",
          position: "sticky",
          top: "0px",
          padding: "8px",
          zIndex: "9999"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XEditorToolbar.prototype, "menuItems", 2);
__decorateClass([
  property({ attribute: false })
], XEditorToolbar.prototype, "menuItemGroupOrder", 2);
__decorateClass([
  property({ attribute: false })
], XEditorToolbar.prototype, "view", 2);
XEditorToolbar = __decorateClass([
  customElement("x-editor-toolbar")
], XEditorToolbar);
export {
  XEditorToolbar,
  renderMenuItem,
  renderMenuItemIcon
};
